import React, { useState,  } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
const { getNewYorkDateTime } = require("../utils/dateUtils");
export default function AgentsWithFiltersAndUpdate() {
const [, setAgents] = useState([]); // ignore state, only setter

  const [filtered, setFiltered] = useState([]);   // filtered agents

  const [loading, setLoading] = useState(false);
 const [loadingRow, setLoadingRow] = useState({});


  // Checkbox selection
  const [, setSelectedAgents] = useState([]); // store _ids
const [selectedProduct, setSelectedProduct] = useState(""); // for dropdown



const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");


const handleProductFilter = async () => {
  if (!selectedProduct) {
    alert("Please select a product first.");
    return;
  }

  try {
    setLoading(true);

    const params = new URLSearchParams();
    params.append("product", selectedProduct);

    // Convert YYYY-MM-DD → MM/DD/YYYY (backend expects this)
    const convertToMMDDYYYY = (dateStr) => {
      const [year, month, day] = dateStr.split("-");
      return `${month}/${day}/${year}`;
    };

    if (fromDate && toDate) {
      params.append("fromDate", convertToMMDDYYYY(fromDate));
      params.append("toDate", convertToMMDDYYYY(toDate));
    }

    const res = await axios.get(
      `https://crm-server-htk6.vercel.app/api/agents/product-filter1?${params.toString()}`
    );

    setAgents(res.data);
    setFiltered(res.data);
    setSelectedAgents([]);

  } catch (err) {
    console.error("❌ Error fetching filtered agents:", err);
  } finally {
    setLoading(false);
  }
};


// Map frontend card type to API-compatible issuer
const mapIssuer = (cardType) => {
  switch (cardType?.toLowerCase()) {
    case "visa":
      return "visa";
    case "master card":
      return "mastercard";
    case "american express":
      return "american-express";
    case "discover":
      return "discover";
    default:
      return "visa"; // default fallback
  }
};





const triggerSemprisPayment = async (row) => {
  try {
    setLoadingRow((prev) => ({ ...prev, [row._id]: true }));

    // Generate unique tracking number
    const trackingNumber = uuidv4();  

    // Build payload for Sempris API
    const payload = {
      address1: row.address,
      address2: row.address2 || "",
      card_cvv: row.cvv,
      card_expiration: row.expiry?.replace("/", "") || "",
      card_number: row.cardNumber?.replace(/-/g, "") || "",
      city: row.city,
      email: row.email,
      first_name: row.firstName,
      last_name: row.lastName,
      issuer: mapIssuer(row.cardType),
      phone: row.phone,
     // sku: "102872",
     sku: "104012",
      source: "43344",
      state: row.state,
      tracking_number: trackingNumber,  // <--- UNIQUE every request!
      vendor_id: "ICAN",
      zip: row.zip,
    };

    //console.log("🔥 Generated Tracking Number:", trackingNumber);
    //console.log("📦 Sempris Payload:", payload);

    const res = await axios.post(
      "https://crm-server-htk6.vercel.app/api/sempris-payment",
      payload
    );

    const apiData = res.data.data || {};
    const apiStatus = res.data.success ? "Success" : "Failed";

    setAgents((prev) =>
      prev.map((a) =>
        a._id === row._id
          ? { ...a, SCAPIStatus: apiStatus, SCAPIResponse: apiData }
          : a
      )
    );

    setFiltered((prev) =>
      prev.map((a) =>
        a._id === row._id
          ? { ...a, SCAPIStatus: apiStatus, SCAPIResponse: apiData }
          : a
      )
    );

    await axios.put(
      `https://crm-server-htk6.vercel.app/api/agents/${row._id}`,
      {
        SCAPIStatus: apiStatus,
        SCAPIResponse: apiData,
        SCTrackingNumber: trackingNumber,   // optional: save unique tracking #
        SCLastUpdated: getNewYorkDateTime(),
        
      }
    );

  } catch (error) {
    console.error("❌ Sempris Payment Error:", error);

    await axios.put(
      `https://crm-server-htk6.vercel.app/api/agents/${row._id}`,
      {
        SCAPIStatus: "Failed",
        SCAPIResponse: error.response?.data || { message: error.message },
        SCLastUpdated: getNewYorkDateTime(),
      }
    );
  } finally {
    setLoadingRow((prev) => ({ ...prev, [row._id]: false }));
  }
};



  return (
    <div style={{ padding: "20px" }} className="allforms-container">
      <h2>Charge Processing for Product - SC</h2>
{loading && (
  <div className="loading-popup">
    <p>Processing... Please wait</p>
  </div>
)}

      {/* ---- Filter Inputs ---- */}
    <div className="form-row" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
  
  {/* Product Dropdown */}
  <select
    value={selectedProduct}
    onChange={(e) => setSelectedProduct(e.target.value)}
    style={{
      padding: "8px 12px",
      fontSize: "14px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      minWidth: "150px",
    }}
  >
    <option value="">Select Product</option>
    <option value="SC">SC</option>
   
  </select>

  {/* From Date */}
  <input
    type="date"
    value={fromDate}
    onChange={(e) => setFromDate(e.target.value)}
    style={{
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #ccc"
    }}
  />

  {/* To Date */}
  <input
    type="date"
    value={toDate}
    onChange={(e) => setToDate(e.target.value)}
    style={{
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #ccc"
    }}
  />

  {/* Go Button */}
  <button
    className="btn save"
    onClick={handleProductFilter}
    style={{
      padding: "8px 16px",
      fontSize: "14px",
      borderRadius: "5px",
      backgroundColor: "#4CAF50",
      color: "#fff",
      border: "none",
      cursor: "pointer",
    }}
  >
    Go
  </button>
</div>


      {/* ---- User Dropdown + Update Button ---- */}

      {loading ? (
        <p>⏳ Loading...</p>
      ) : (
        <div
  className="table-container1" style={{ marginTop: "20px", overflowX: "auto" 
  }}
>


<table className="report-table table-container" style={{ borderCollapse: "collapse", width: "100%" }}>
<thead>
<tr>
{/* ⭐ NEW FIELDS ⭐ */}
<th>CustomerID</th>
<th>First Name</th>
<th>Last Name</th>
<th>Email</th>
<th>Phone</th>
<th>Charge</th>
<th>Messagg</th>
<th>Transaction_id </th>
<th>Status </th>
<th>Error Msg</th>
<th>SCLastUpdated</th>


 
</tr>
</thead>


<tbody>
  {filtered.length === 0 ? (
    <tr>
      <td colSpan="11" style={{ textAlign: "center" }}>No records found</td>
    </tr>
  ) : (
    filtered.map((a) => (
      <tr key={a._id} style={{ borderBottom: "1px solid #ddd" }}>
        
        {/* REMOVE CHECKBOX COLUMN */}
  <td>{a.CustomerID || ""}</td>
        <td>{a.firstName || ""}</td>
        <td>{a.lastName || ""}</td>
        <td>{a.email || ""}</td>
        <td>{a.phone || ""}</td>
         <td>
     <button
  className="btn save"
  onClick={() => triggerSemprisPayment(a)}
  disabled={loadingRow[a._id]} // disable only this row's button
  style={{
    padding: "6px 12px",
    fontSize: "13px",
    backgroundColor: "#007bff",
    color: "#fff",
    borderRadius: "5px",
    cursor: "pointer",
  }}
>
  {loadingRow[a._id] ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Processing...
    </>
  ) : (
    "Post API"
  )}
</button>

        </td>
        <td>{a.SCAPIResponse?.message || ""}</td>
<td>{a.SCAPIResponse?.transaction_id || ""}</td>
<td>{a.SCAPIStatus || ""}</td>
      <td>
  {Array.isArray(a.SCAPIResponse?.error_msg)
    ? a.SCAPIResponse.error_msg[a.SCAPIResponse.error_msg.length - 1]?.message
    : a.SCAPIResponse?.error_msg || ""}
</td>

<td>{a.SCLastUpdated|| ""}</td>


        {/* ⭐ NEW POST BUTTON IN EVERY ROW ⭐ */}
       

      </tr>
    ))
  )}
</tbody>

</table>
        </div>
      )}
    </div>
  );
}
